import { render, staticRenderFns } from "./TypeApartment.vue?vue&type=template&id=495dc507&"
import script from "./TypeApartment.vue?vue&type=script&lang=js&"
export * from "./TypeApartment.vue?vue&type=script&lang=js&"
import style0 from "./TypeApartment.vue?vue&type=style&index=0&id=495dc507&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports